import BaseApi from '../base/base'
import Banner from '../../models/banner'

export default class BannerApi extends BaseApi {
  constructor() {
    super()
    this.path = '/banners'
  }

  async index(params = {type: ""}) {
    const response = await this.getRequest(params)
    return response.data.map((element) => {
      return new Banner(element)
    })
  }
}
